import { render, staticRenderFns } from "./manhattanGraph.vue?vue&type=template&id=1ba9978e&scoped=true"
import script from "./manhattanGraph.vue?vue&type=script&lang=js"
export * from "./manhattanGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9978e",
  null
  
)

export default component.exports